import React from "react";
import { FaHourglassHalf } from "react-icons/fa";
import "./LoadingOverlay.css";

const LoadingOverlay = ({ message }) => {
  return (
    <div className="overlay">
      <div className="overlay-content">
        {/* Ícono reloj de arena animado */}
        <FaHourglassHalf className="hourglass-icon" />

        {/* Mensaje */}
        <p className="overlay-message">{message}</p>
      </div>
    </div>
  );
};

export default LoadingOverlay;
